import React from 'react';
import { Chip, Grid, makeStyles, Theme, Tooltip } from '@material-ui/core';
import { MedisanteTargetSystem } from '../../types';
import { Block, InfoOutlined, Warning } from '@material-ui/icons';
import { statusDescriptions } from '../../../Devices/components/Filters/constants';

interface Props {
  targetSystem: MedisanteTargetSystem;
  incompatibile: boolean;
}

const useStyles = makeStyles((theme: Theme) => ({
  icon: {
    marginRight: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
    '&:last-child': {
      marginRight: 0,
    },
  },
}));

const getResponsePill = (ts: MedisanteTargetSystem) => {
  if (!!ts.lastStatusCode) {
    return statusDescriptions[ts.lastStatusCode] ? (
      <Tooltip title={statusDescriptions[ts.lastStatusCode]}>
        <Chip
          label={ts.lastStatusCode}
          deleteIcon={<InfoOutlined />}
          onDelete={() => {
            /* needed for show icon */
          }}
        />
      </Tooltip>
    ) : (
      <Chip label={ts.lastStatusCode} />
    );
  }
  return null;
};

const getIncompatiblityIcon = (show: boolean) => {
  if (show) {
    const color = 'rgb(250, 84, 54)';
    return (
      <Tooltip
        title={`Devices and/or measurements may not be supported wholly or partly`}
      >
        <Warning htmlColor={color} />
      </Tooltip>
    );
  }
  return null;
};

const getBlockedIcon = (show: boolean) => {
  if (show) {
    const color = 'rgb(250, 84, 54)';
    return (
      <Tooltip title={`Webhook blocked - measurement blocking in place`}>
        <Block htmlColor={color} />
      </Tooltip>
    );
  }
  return null;
};

function TargetSystemStatusIcons(props: Props) {
  const { targetSystem } = props;
  const classes = useStyles();
  const format = targetSystem.format && targetSystem.format.match(/fhir/i);

  const icons = [
    getResponsePill(targetSystem),
    getIncompatiblityIcon(props.incompatibile && !!format),
    getBlockedIcon(targetSystem.deactivated || false),
  ]
    .filter((icon) => !!icon)
    .map((icon, index) => (
      <Grid key={index} item className={classes.icon}>
        {icon}
      </Grid>
    ));

  return (
    <Grid container justifyContent="flex-start">
      {icons}
    </Grid>
  );
}

export default TargetSystemStatusIcons;
